import React from 'react';

import Tooltip from 'ggApp/shared/containers/tooltip';
import 'react-tippy/dist/tippy.css';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { BadgeWrap, PrefixText, ToolTipTriggerText } from './styles';

export default class RentalPeriodBadge extends React.PureComponent {
    render() {
        const { className } = this.props;
        return (
            <BadgeWrap className={className}>
                <PrefixText>
                    <Translator tk="PRODUCT_CARD_RENTAL_PERIOID_TEXT_PREFIX" />
                </PrefixText>
                <Tooltip tooltipTK="TOOLTIP_TEXT_MINIMUM_RENTAL_PERIOD">
                    <ToolTipTriggerText>
                        <Translator tk="SERVICE_TEXT_MINIUM_RENTAL_PERIOD" />
                    </ToolTipTriggerText>
                </Tooltip>
            </BadgeWrap>
        );
    }
}
